/**
 * Catalog ids (apps/apolloserver/src/access/catalog.ts) that apps/web checks for access levels.
 * Renaming or removing such a node in the catalog: update this file.
 * Naming: views without suffix, groups end in `_GROUP`, blocks in `_BLOCK` (checked by the spec).
 */
export const SUPPLIERS_ACCESS_NODE = 'suppliers';
export const TASKS_ACCESS_NODE = 'tasks';
export const PROJECTS_ACCESS_NODE = 'projects';
export const SALES_ACCESS_NODE = 'sales';
export const ORDERS_ACCESS_NODE = 'orders';
export const INVOICES_ACCESS_NODE = 'invoices';
export const OFFERS_ACCESS_NODE = 'offers';
export const ITEM_STORAGES_ACCESS_NODE = 'inventory';
export const ITEM_INVENTORIES_ACCESS_NODE = 'item-inventories';
export const ITEM_TRANSACTIONS_ACCESS_NODE = 'item-transactions';
export const ITEMS_ACCESS_NODE = 'material-master';
export const ITEM_PACKAGES_ACCESS_NODE = 'item-packages';
export const APPOINTMENT_PLANNING_ACCESS_NODE = 'appointment-planning';
export const APPOINTMENT_SLOTS_ACCESS_NODE = 'appointment-slots';
export const TIME_TRACKING_ACCESS_NODE = 'time-tracking';

export const DASHBOARD_APPOINTMENTS_TODAY_BLOCK = 'dashboard-appointments-today';
export const DASHBOARD_MY_TIME_TRACKING_BLOCK = 'dashboard-my-time-tracking';

export const PROJECTS_EXPORT_BLOCK = 'projects-export';

export const PROJECT_INTERNAL_TAB_GROUP = 'project-internal-tab';
export const PROJECT_BASE_INFORMATION_BLOCK = 'project-base-information';
export const PROJECT_PRESENTATIONS_BLOCK = 'project-presentations';
export const PROJECT_CLARIFICATION_BLOCK = 'project-clarification';

export const PROJECT_CUSTOMER_TAB_GROUP = 'project-customer-tab';
export const PROJECT_CUSTOMER_MASTER_DATA_BLOCK = 'project-customer-master-data';
export const PROJECT_CUSTOMER_INSTALLATION_ADDRESS_BLOCK = 'project-customer-installation-address';
export const PROJECT_CUSTOMER_TAX_BANK_BLOCK = 'project-customer-tax-bank';
export const PROJECT_CUSTOMER_ADDITIONAL_INFORMATION_BLOCK =
  'project-customer-additional-information';
export const PROJECT_PARTIES_BLOCK = 'project-parties';

export const PROJECT_COMMUNICATION_TAB_GROUP = 'project-communication-tab';
export const PROJECT_TASKS_BLOCK = 'project-tasks';
export const PROJECT_EMPLOYER_COMMUNICATION_BLOCK = 'project-employer-communication';
export const PROJECT_POSTS_BLOCK = 'project-posts';
export const PROJECT_EMAIL_BLOCK = 'project-email';

export const PROJECT_CONFIGURATION_TAB_GROUP = 'project-configuration-tab';
export const PROJECT_BASE_CONFIGURATION_BLOCK = 'project-base-configuration';
export const PROJECT_EXTENDED_CONFIGURATION_BLOCK = 'project-extended-configuration';

export const PROJECT_TECHNICAL_REVIEW_TAB_GROUP = 'project-technical-review-tab';
export const PROJECT_TECHNICAL_REVIEW_DC_BLOCK = 'project-technical-review-dc';
export const PROJECT_TECHNICAL_REVIEW_AC_BLOCK = 'project-technical-review-ac';
export const PROJECT_TIME_TRACKING_SUMMARY_BLOCK = 'project-time-tracking-summary';

export const PROJECT_MATERIAL_TAB_GROUP = 'project-material-tab';
export const PROJECT_ORDERS_BLOCK = 'project-orders';
export const PROJECT_ITEM_INVENTORY_BLOCK = 'project-item-inventory';
export const PROJECT_CONSUMED_ITEMS_BLOCK = 'project-consumed-items';

export const PROJECT_INSTALLATION_TAB_GROUP = 'project-installation-tab';
export const PROJECT_ROUGH_PLANNING_BLOCK = 'project-rough-planning';
export const PROJECT_INSTALLATION_APPOINTMENTS_BLOCK = 'project-installation-appointments';
export const PROJECT_APPOINTMENT_SLOTS_BLOCK = 'project-appointment-slots';
export const PROJECT_APPOINTMENT_NOTES_BLOCK = 'project-appointment-notes';
export const PROJECT_TIME_TRACKING_BLOCK = 'project-time-tracking';

export const PROJECT_POWER_COMPANY_TAB_GROUP = 'project-power-company-tab';
export const PROJECT_POWER_COMPANY_BLOCK = 'project-power-company';
export const PROJECT_POWER_COMPANY_COMMUNICATION_BLOCK = 'project-power-company-communication';
export const PROJECT_MEASUREMENT_POINT_OPERATOR_BLOCK = 'project-measurement-point-operator';
export const PROJECT_ACCOUNTING_TAB_GROUP = 'project-accounting-tab';
export const PROJECT_INVOICES_BLOCK = 'project-invoices';
export const PROJECT_INVOICE_APPROVAL_BLOCK = 'project-invoice-approval';
export const PROJECT_OFFERS_BLOCK = 'project-offers';
export const PROJECT_DOCUMENTS_TAB_GROUP = 'project-documents-tab';
export const PROJECT_DOCUMENTS_BLOCK = 'project-documents';
export const PROJECT_BANK_TAB_GROUP = 'project-bank-tab';
export const PROJECT_BANK_CUSTOMER_BLOCK = 'project-bank-customer';
export const PROJECT_BANK_SELF_DISCLOSURE_BLOCK = 'project-bank-self-disclosure';
export const PROJECT_BANK_EMPLOYMENT_INCOME_BLOCK = 'project-bank-employment-income';
export const PROJECT_BANK_SELF_EMPLOYMENT_BLOCK = 'project-bank-self-employment';
export const PROJECT_BANK_RENTAL_INCOME_BLOCK = 'project-bank-rental-income';
export const PROJECT_BANK_CAPITAL_ASSETS_BLOCK = 'project-bank-capital-assets';
export const PROJECT_BANK_SUMMARY_BLOCK = 'project-bank-summary';
export const PROJECT_MEASUREMENT_REPORT_TAB_GROUP = 'project-measurement-report-tab';
export const PROJECT_MEASUREMENT_REPORT_BUILD_BLOCK = 'project-measurement-report-build';
export const PROJECT_MEASUREMENT_REPORT_VERIFICATION_BLOCK =
  'project-measurement-report-verification';
export const PROJECT_MEASUREMENT_REPORT_APPROVAL_BLOCK = 'project-measurement-report-approval';
export const PROJECT_MEASUREMENT_REPORT_DATA_BLOCK = 'project-measurement-report-data';
export const PROJECT_ACCEPTANCE_REPORT_TAB_GROUP = 'project-acceptance-report-tab';
export const PROJECT_ACCEPTANCE_REPORT_BUILD_BLOCK = 'project-acceptance-report-build';
export const PROJECT_ACCEPTANCE_REPORT_VERIFICATION_BLOCK =
  'project-acceptance-report-verification';
export const PROJECT_ACCEPTANCE_REPORT_APPROVAL_BLOCK = 'project-acceptance-report-approval';
export const PROJECT_ACCEPTANCE_REPORT_DATA_BLOCK = 'project-acceptance-report-data';
export const PROJECT_SERVICE_REPORT_TAB_GROUP = 'project-service-report-tab';
export const PROJECT_SERVICE_REPORT_BUILD_BLOCK = 'project-service-report-build';
export const PROJECT_SERVICE_REPORT_VERIFICATION_BLOCK = 'project-service-report-verification';
export const PROJECT_SERVICE_REPORT_APPROVAL_BLOCK = 'project-service-report-approval';
export const PROJECT_SERVICE_REPORT_DATA_BLOCK = 'project-service-report-data';
export const PROJECT_QUALITY_REPORT_TAB_GROUP = 'project-quality-report-tab';
export const PROJECT_QUALITY_REPORT_DATA_BLOCK = 'project-quality-report-data';
export const PROJECT_SALES_REPORT_TAB_GROUP = 'project-sales-report-tab';
export const PROJECT_SALES_REPORT_BUILD_BLOCK = 'project-sales-report-build';
export const PROJECT_SALES_REPORT_DATA_BLOCK = 'project-sales-report-data';

export const PROJECT_CALCULATION_TAB_GROUP = 'project-calculation-tab';
export const PROJECT_CALCULATION_BLOCK = 'project-calculation';
export const PROJECT_FINANCIAL_MODEL_BLOCK = 'project-financial-model';
export const PROJECT_PLANT_DATA_BLOCK = 'project-plant-data';
export const PROJECT_FINANCING_BLOCK = 'project-financing';
export const PROJECT_IAB_TAX_DATA_BLOCK = 'project-iab-tax-data';
